<template>
  <modal :show="show" @close="close">
    <v-flex class="ma-1" slot="title">Zleć wydruk karty</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.collectionPointId">
            <v-select item-text="text" label="Punkt odbioru karty" item-value="value" :items="collectionPoints" />
          </w-schema>
        </v-flex>
      </v-layout>
    </div>

    <v-layout slot="actions">
      <v-spacer />

      <v-btn color="error" flat @click="$emit('close')">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zatwierdź</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { WSchema } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import Modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import { notificationsMixin } from '@/mixins/notifications';
import schema from '@/schemas/cardOrderPrint.schema';

function emptyData() {
  return {
    collectionPointId: undefined
  };
}

// @vuese
// Modal zlecenia druku karty klienta
// @group Client-Profile
export default {
  schema,
  mixins: [manageMixin(undefined, {}, emptyData), notificationsMixin],
  props: {
    // Identyfikator karty
    cardId: {
      type: Number,
      required: false
    }
  },
  methods: {
    // @vuese
    // Emituje event do zapisu danych
    save() {
      this.$emit('save', { ...this.model, id: this.cardId });
    }
  },
  components: { WSchema, Modal },
  computed: {
    ...mapState({
      collectionPoints: state => {
        return state.collectionPoint.list.map(item => ({ text: item.name, value: item.id }));
      }
    })
  },
  watch: {
    show(val) {
      if (val) {
        this.$store.dispatch('collectionPoint/list');
      }
    }
  }
};
</script>
